<template>
  <div class="row boxes-row">
    <div class="col-lg-4" v-for="box in leaderboards" :key="box.link">
      <LeaderboardBox :box="box"></LeaderboardBox>
    </div>
  </div>
</template>

<script>
import LeaderboardBox from "@/components/quiz/LeaderboardBox";
export default {
  name: "LeaderboardList",
  components: {LeaderboardBox},
  computed: {
    leaderboards() {
      let leaderboard = [
        {
          idQuiz:"global",
          "type":null,
          "name":"Global leaderboard",
        }
      ]
      return leaderboard.concat(this.$store.getters.leaderboards)
    },
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Leaderboard']);
    window._paq.push(['trackPageView']);
  }
}
</script>
